import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import type { Placement } from "./types.ts";

type TrayContext = {
  show: boolean;
  active: boolean;
  placement: Placement;
  items: ReactNode[];
};

export const TrayContext = createContext<TrayContext | undefined>(undefined);

export const useTray = () => {
  const context = useContext(TrayContext);

  if (!context) {
    throw new Error(`Expected TrayContext in ancestor tree.`);
  }

  return context;
};
